import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaWhatsapp, FaLinkedinIn } from "react-icons/fa";
import { FiMenu, FiX } from "react-icons/fi";

function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    function scrollHandler() {
      setScrolled(window.scrollY >= 20);
    }

    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={scrolled ? "site-header scrolled" : "site-header"}>
      <div className="site-header-inner">
        <Link to="/" className="brand-logo" onClick={closeMenu}>
          <span className="brand-line">
            Soheel<span className="brand-dot">.dev</span>
          </span>
          <span className="brand-sub">Cloud & DevOps Engineer</span>
        </Link>

        <nav className="site-nav">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? "site-nav-link active" : "site-nav-link"
            }
            end
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive ? "site-nav-link active" : "site-nav-link"
            }
          >
            About
          </NavLink>
          <NavLink
            to="/project"
            className={({ isActive }) =>
              isActive ? "site-nav-link active" : "site-nav-link"
            }
          >
            Projects
          </NavLink>
          <NavLink
            to="/ourstory"
            className={({ isActive }) =>
              isActive ? "site-nav-link active" : "site-nav-link"
            }
          >
            Our Story
          </NavLink>
          <NavLink
            to="/contactus"
            className={({ isActive }) =>
              isActive ? "site-nav-link active" : "site-nav-link"
            }
          >
            Contact
          </NavLink>
        </nav>

        <div className="header-actions">
          <a
            href="https://www.linkedin.com/in/soheel-gadad"
            target="_blank"
            rel="noreferrer"
            className="btn btn-outline btn-icon"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
          <Link to="/resume" className="btn btn-resume">
            View Resume
          </Link>
          <a
            href="https://wa.me/917498814658?text=Hi%20Soheel!%20I%20have%20a%20project%20in%20mind."
            target="_blank"
            rel="noreferrer"
            className="btn btn-hire"
          >
            <FaWhatsapp /> Hire Me
          </a>
        </div>

        <button
          className="hamburger"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="Toggle navigation"
        >
          {menuOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>

      <nav className={menuOpen ? "mobile-nav show" : "mobile-nav"}>
        <NavLink to="/" className="site-nav-link" end onClick={closeMenu}>
          Home
        </NavLink>
        <NavLink to="/about" className="site-nav-link" onClick={closeMenu}>
          About
        </NavLink>
        <NavLink to="/project" className="site-nav-link" onClick={closeMenu}>
          Projects
        </NavLink>
        <NavLink to="/resume" className="site-nav-link" onClick={closeMenu}>
          Resume
        </NavLink>
        <NavLink to="/ourstory" className="site-nav-link" onClick={closeMenu}>
          Our Story
        </NavLink>
        <NavLink to="/contactus" className="site-nav-link" onClick={closeMenu}>
          Contact
        </NavLink>
        <div className="mobile-actions">
          <Link to="/resume" className="btn btn-resume" onClick={closeMenu}>
            View Resume
          </Link>
          <a
            href="https://wa.me/917498814658?text=Hi%20Soheel!%20I%20have%20a%20project%20in%20mind."
            target="_blank"
            rel="noreferrer"
            className="btn btn-hire"
          >
            <FaWhatsapp /> Hire Me
          </a>
        </div>
      </nav>
    </header>
  );
}

export default NavBar;